// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3gPNU","text":"SelectPayment_text__2d-fX","title":"SelectPayment_title__3XX__","btn":"SelectPayment_btn__3IO-E"};